import React, { FC } from 'react';
import parse from 'html-react-parser';
import { IArticleBox1 } from './params';
import { IArticle } from '../../../types/article';
import Styles from './styles';

import convertToSlug from '../../../utils/convertToSlug';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { routing } from '../../../translates';

const ArticleBox: FC<{
  config: IArticleBox1;
  article: IArticle;
  withCategory?: boolean;
  activeCategory?: string;
  language: string;
}> = ({ config, article, withCategory, activeCategory, language }) => {
  const cdnUrl = process.env.GATSBY_CDN_URL;
  const articleLink = `${routing[language].article}/${convertToSlug(article.name)}-${article.id}/`;
  const imageSrc = `${cdnUrl}/g-${article.imagePath}`;
  const shortDescription = parse(article.description.replace(/(<([^>]+)>)/gi, '').slice(0, 300) || ' ');

  return (
    <Styles $config={config}>
      <div className="article-box">
        <a href={articleLink} className="article-box-image">
          <img loading="lazy" src={imageSrc} alt={article.name} />
        </a>
        <div className="article-box-content">
          {withCategory ? (
            <a
              href={`${routing[language].articles}/${convertToSlug(article.categoryName)}`}
              className={`article-box-category ${activeCategory === article.categoryName ? 'disabled' : ''}`}
            >
              {article.categoryName} <FontAwesomeIcon icon={faAngleRight} />
            </a>
          ) : null}

          <h3 className="article-box-title">
            <a href={articleLink}>{article.name}</a>
          </h3>

          <p className="article-box-description">{shortDescription}</p>
          <a href={articleLink} className="article-box-button">
            <FontAwesomeIcon icon={faAngleRight} />
          </a>
        </div>
      </div>
    </Styles>
  );
};

export default ArticleBox;
